import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Maybe } from "@ispb/react-hooks";
import { Fragment, createElement } from "react";
import { STANDARD_SPACING } from "../config";
export default function Heading(props) {
    return createElement(props.level, {
        className: "d-flex align-items-center mb-" + ((props.margin ?? true) ? STANDARD_SPACING : 0) + " " + props.className,
        children: (_jsxs(Fragment, { children: [props.title, _jsx(Maybe, { value: props.subtitle, children: subtitle => _jsx("small", { className: "text-muted ms-" + STANDARD_SPACING, children: subtitle }) })] }))
    });
}
